t = require('views/internal/teacup-with-helpers')('member_cards_base')

module.exports = t.renderable ({ showGroup }) ->
  t.div '.window-module.u-gutter.member-cards-options', ->
    t.a '.quiet-button.mod-with-image.js-toggle-sort', { href: '#' }, ->
      t.icon 'overflow-menu-horizontal', { class: 'quiet-button-icon' }
      t.span '.js-sort-text'

    if showGroup
      t.a '.quiet-button.mod-with-image.js-set-group', { href: '#' }, ->
        t.icon 'filter', { class: 'quiet-button-icon' }
        t.span '.js-group-text'

    t.a '.quiet-button.mod-with-image.js-set-filter', { href: '#' }, ->
      t.icon 'filter', { class: 'quiet-button-icon' }
      t.span '.js-filter-text'

  t.div '.js-cards-content'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_cards_base.coffee